/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';

type Props = {
  bgColor: string,
  children: any,
  textColor: string
};

const StyledLabel = styled.span(({ bgColor, textColor, theme }) => ({
  backgroundColor: bgColor,
  borderRadius: theme.borderRadius.tiny,
  color: textColor,
  display: 'flex',
  fontSize: '0.6rem',
  justifyContent: 'center',
  lineHeight: 1.7,
  minWidth: '0.9rem',
  textAlign: 'center',
  textTransform: 'uppercase'
}));

function Label({ bgColor, children, textColor }: Props) {
  return (
    <StyledLabel bgColor={bgColor} textColor={textColor}>
      {children}
    </StyledLabel>
  );
}

export default Label;
